import React, { Component } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import XLSX from 'xlsx';

export class UploadResults extends Component
{
  
    formatIncidentData = () =>
    {
      let dataRows = [];
      if (this.props.results.HeaderRow) {
        let firstRow = [];
        this.props.results.HeaderRow.forEach(rowHeading => {
          firstRow.push(rowHeading);
        });
        firstRow.push("Error");
      /*
    'LocalIncidentID',
		'FireDiscoveryDate',
		'FireDiscoveryTime',
		'FireReportingAgencyUnitIdentifier',
		'State',
		'Latitude',
		'Longitude',
		'StatisticalCauseCode',
		'FinalFireAcreQuantity',
		'FireContainmentDate',
		'FireContainmentTime',
		'IncidentName',
		'StateFIPS',
		'County',
		'CountyFIPS',
		'District',
		'OwnershipCode',
		'ResidencesThreatened',
		'ResidencesDestroyed',
		'OtherStructuresThreatened',
		'OtherStructuresDestroyed',
		'NumberInjuries',
		'NumberFatalities',
		'DeleteFlag'
    */

      dataRows.push(firstRow);
      
      var i = 0;
      this.props.results.SkippedIncidents.forEach(incident => {
        let newRow = [];
        incident.forEach(fieldValue => {
          newRow.push(fieldValue);
        });
        newRow.push(this.props.results.SkippedIncidentDetails[i]);
        dataRows.push(newRow);
        i++;
      });
    }
     /* for (let i = 0; i < this.props.results.SkippedIncidents.length; i++)
      {
        let newRow = [
          this.props.results.SkippedIncidents[i].LocalIncidentID,
      		this.props.results.SkippedIncidents[i].FireDiscoveryDate,
      		this.props.results.SkippedIncidents[i].FireDiscoveryTime,
      		this.props.results.SkippedIncidents[i].FireReportingAgencyUnitIdentifier,
      	  this.props.results.SkippedIncidents[i].State,
      		this.props.results.SkippedIncidents[i].Latitude,
      		this.props.results.SkippedIncidents[i].Longitude,
      		this.props.results.SkippedIncidents[i].StatisticalCauseCode,
      		this.props.results.SkippedIncidents[i].FinalFireAcreQuantity,
      		this.props.results.SkippedIncidents[i].FireContainmentDate,
      		this.props.results.SkippedIncidents[i].FireContainmentTime,
      		this.props.results.SkippedIncidents[i].IncidentName,
      		this.props.results.SkippedIncidents[i].StateFIPS,
      		this.props.results.SkippedIncidents[i].County,
      		this.props.results.SkippedIncidents[i].CountyFIPS,
      		this.props.results.SkippedIncidents[i].District,
      		this.props.results.SkippedIncidents[i].OwnershipCode,
      		this.props.results.SkippedIncidents[i].ResidencesThreatened,
      		this.props.results.SkippedIncidents[i].ResidencesDestroyed,
      		this.props.results.SkippedIncidents[i].OtherStructuresThreatened,
      		this.props.results.SkippedIncidents[i].OtherStructuresDestroyed,
      		this.props.results.SkippedIncidents[i].NumberInjuries,
      		this.props.results.SkippedIncidents[i].NumberFatalities,
      		this.props.results.SkippedIncidents[i].DeleteFlag,
          this.props.results.SkippedIncidentDetails[i]
        ]; */
      return dataRows;
    }

    writeCsv = () =>
    {
      const workbook = XLSX.utils.book_new();
      let incidentData = this.formatIncidentData();
      let incidentSheet = XLSX.utils.aoa_to_sheet(incidentData);
      XLSX.utils.book_append_sheet(workbook, incidentSheet, "RejectedRecords");

      XLSX.writeFile(workbook, "RejectedRecords.xlsx");
    }

    componentDidUpdate = (prevProps, prevState) =>
    {
      if (this.props.results && this.props.results !== prevProps.results)
      {
          if (this.props.results.SkippedIncidents && this.props.results.SkippedIncidents.length > 0)
          {
            this.writeCsv();
          }
      }
    }

   render()
   {
       return (!this.props.isVisible) ? (<div></div>) : (
         <Table>
         <TableBody>
          <TableRow>
            <TableCell style={{fontWeight:"bold", whiteSpace: 'nowrap'}}>Records parsed from file:</TableCell>
            <TableCell>{this.props.results.NumberOfParsedRecords}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell style={{fontWeight:"bold", whiteSpace: 'nowrap'}}>New incidents created:</TableCell>
            <TableCell>{this.props.results.NumberOfUploadedIncidents}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell style={{fontWeight:"bold", whiteSpace: 'nowrap'}}>Existing incidents deleted:</TableCell>
            <TableCell>{this.props.results.NumberOfDeletedRecords}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell style={{fontWeight:"bold", whiteSpace: 'nowrap'}}>Number of skipped records:</TableCell>
            <TableCell>{this.props.results.SkippedRecordCount}</TableCell>
          </TableRow>
          { this.props.results.Rejected &&
            <TableRow>
              <TableCell style={{fontWeight:"bold", whiteSpace: 'nowrap'}}>Error:</TableCell>
              <TableCell>{this.props.results.ErrorText}</TableCell>
            </TableRow>
          }
          {this.props.results.SkippedRecordCount > 0 &&
            <TableRow>
              <TableCell style={{fontWeight:"bold", whiteSpace: 'nowrap'}}  colSpan={2}>See downloaded spreadsheet for rejected records and related data issues.</TableCell>
            </TableRow>
          }

           </TableBody>
         </Table>
       );
     }
}

export default UploadResults;
